export default {
    setJwt(value) {
        localStorage.setItem('jwt', value)
        //sessionStorage.setItem('jwt', value)
    },
    removeJwt() {
        localStorage.removeItem('jwt')
        //sessionStorage.removeItem('jwt')
    },
    getJwt() {
        return localStorage.getItem('jwt')
        //return sessionStorage.getItem('jwt')
    },
    getJwtData() {
        let jwt = this.getJwt()
        return jwt ? JSON.parse(atob(jwt.split('.')[1])) : null
    },
    getJwtIdentity() {
        let jwtData = this.getJwtData()
        return jwtData ? jwtData.sid : null
    },
    getJwtSubject() {
        let jwtData = this.getJwtData()
        return jwtData ? jwtData.sub : null
    },
    getJwtRoles() {
        let jwtData = this.getJwtData()
        return jwtData ? jwtData['http://schemas.microsoft.com/ws/2008/06/identity/claims/role'] : null
    },
    getJwtIssuer() {
        let jwtData = this.getJwtData()
        return jwtData ? jwtData.iss : null
    },
    getJwtExpiration() {
        let jwtData = this.getJwtData()
        return jwtData ? jwtData.exp : null
    },
    jwtExpired() {
        // let jwtExpiration = this.getJwtExpiration();
        // if (jwtExpiration == null)
        //     return true
        if (new Date(this.getJwtExpiration() * 1000) < new Date()) {
            return true
        } else {
            console.info('Token expiration: ' + new Date(this.getJwtExpiration() * 1000))
            return false
        }
    }
}